import angular from 'angular';

angular.module('cloudX').directive('cxVatPercentage', [
  'optionsSvc',
  function(optionsSvc) {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<select ng-model="vat" ng-options="p.value as p.label for p in percentages" ' +
        'class="form-control" dir="rtl">' +
        '<option ng-show="!vat && vat!==0" data-translate value="">Set a percentage</option>' +
        '</select>',
      scope: {
        vat: '=data',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.percentages = optionsSvc.getOptions('vatPercentage');
        },
      ],
    };
  },
]);
